import { render } from "./Home.vue?vue&type=template&id=b2a2a2c4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kadern\\Desktop\\doc_root\\head-check\\vue-head-check\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__